module.exports = __webpack_public_path__ + "img/LOGO_1EN.29c35717.png";